const features = [];
const classes = document.documentElement.classList;

// https://polyfill.io/v3/url-builder/
('fetch' in window)              || features.push('fetch');
('Promise' in window)            || features.push('Promise');
('assign' in Object)             || features.push('Object.assign');
('from' in Array)                || features.push('Array.from');
('find' in Array.prototype)      || features.push('Array.prototype.find');
('includes' in Array.prototype)  || features.push('Array.prototype.includes');
('closest' in Element.prototype) || features.push('Element.prototype.closest');
('matches' in Element.prototype) || features.push('Element.prototype.matches');

if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window) || !('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
  features.push('IntersectionObserver', 'IntersectionObserverEntry');
}

export default function load(done) {
  if (features.length === 0) return done();
  const script = document.createElement('script');
  script.src = `//polyfill.io/v3/polyfill.min.js?features=${features.join(',')}&flags=gated&ua=${window.navigator.userAgent}`;
  script.onload = done;
  document.body.appendChild(script);
};

// IE or no grid or no object-fit
const unsupported = (
  !!document.documentMode ||
  typeof document.body.style.grid !== 'string' ||
  'objectFit' in document.documentElement.style === false
);

if (unsupported) {

  const script = document.createElement('script');
  script.src = 'https://unpkg.com/css-vars-ponyfill@2.3.1';
  script.onload = () => window.cssVars({
    // https://jhildenbiddle.github.io/css-vars-ponyfill/
    // TODO: IE11 support?
    include: 'style:not(#fonts-css)',
  });

  const div = document.createElement('div');
  div.className = 'msie-warning';
  div.innerHTML = 'You are using an outdated and unsupported browser. Please <a href="https://browsehappy.com/?locale=en" target="_blank">upgrade</a> for a better experience.';

  document.body.appendChild(script);
  document.body.appendChild(div);
  classes.add('msie');
}